import React from 'react';
import { useNavigate } from 'react-router-dom';

import Img1 from '../../img/products/bombas/BombasTurbina.png';
import Img2 from '../../img/products/bombas/BombasTurbina/BombaTurbina1.png';
// import Img3 from '../../img/products/bombas/BombasAutocebantes/BombasAutocebantes3.png';
// import Img4 from '../../img/products/bombas/BombasCentrifugas.png';

const BombasTurbinaVertical = () => {
  const navigate = useNavigate();

  return (
    <div className="container my-5">
      <h2 className="mb-4 text-center">Bombas De Turbina Vertical</h2>

      {/* Estilos inline o puedes mover esto a tu CSS */}
      <style>{`
        .img-hover-zoom {
          transition: transform 0.3s ease;
        }

        .img-hover-zoom:hover {
          transform: scale(1.05);
        }
      `}</style>

      <div className="row align-items-start mb-2">
        {/* Columna Izquierda: texto descriptivo */}
        <div className="col-md-7">
          <p className="lead text-justify">
            Las bombas de turbina vertical son un tipo de bomba centrífuga diseñada para aplicaciones en las
            que el suministro de agua proviene de fuentes subterráneas, como pozos o depósitos. Estas bombas
            son conocidas por su alta eficiencia y capacidad para manejar grandes volúmenes de agua a alta presión.
          </p>
          <p className="lead text-justify">
            Permite una instalación eficiente en espacios reducidos y facilita el acceso a fuentes de agua
            subterráneas. Las bombas de turbina vertical suelen tener múltiples impulsores montados en serie, lo
            que aumenta la presión del agua a medida que se eleva desde el fondo del pozo.
          </p>
          <p className="lead text-justify">
            El eje largo de la bomba permite sumergirla en pozos profundos, asegurando un suministro constante
            de agua. Su diseño permite un uso eficiente de la energía, reduciendo los costos operativos.
          </p>
        </div>
        {/* Columna derecha: imágenes en cuadrícula */}
        <div className="col-md-4">
          <div className="row g-4">
            <div className="col-6">
              <img src={Img1} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 1" />
            </div>
            <div className="col-6">
              <img src={Img2} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 2" />
            </div>
            {/* <div className="col-6">
              <img src={Img3} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 3" />
            </div>
            <div className="col-6">
              <img src={Img4} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 4" />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BombasTurbinaVertical;
